module.exports = __webpack_public_path__ + "img/frame (33).ea76e83c.jpg";